import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { isEmpty, sortBy } from 'lodash';

import moment from 'moment';
import DatePicker from 'react-datepicker';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import AutoComplete from '@material-ui/lab/Autocomplete';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';
import Chip from '@material-ui/core/Chip';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import BobRadioButton from '../../../components/BobRadioButton';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { Splitter } from '@progress/kendo-react-layout';

import * as ReportingActions from '../../../actions/reportingActions';

import * as classes from './ReportConfigurationCreate.module.css';

const ValidationSchema = Yup.object().shape({
    description: Yup.string()
        .required(),
    client: Yup.string()
        .required(),
    site: Yup.string()
        .required(),
    equipmentType: Yup.array(),
    equipment:     Yup.array()
        .when('system', {
            is:   (value) => isEmpty(value),
            then: Yup.array().required()
        }),
    system: Yup.array()
        .when('equipment', {
            is:   (value) => isEmpty(value),
            then: Yup.array().required()
        }),
    stauts:    Yup.string(),
    symbol:    Yup.string(),
    number:    Yup.number(),
    timeRange: Yup.string()
        .required()
}, [['equipment', 'system'], ['client', 'site']]);

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const timeRanges = ['Monthly', 'Today', 'Week to Day', 'Month to Day', 'Quarter to Day', 'Previous Day', 'Previous Week', 'Previous Month', 'Previous Quarter', 'Custom Date'];

const MenuProps = {
    disablePortal:      true,
    getContentAnchorEl: () => null,
    PaperProps:         {
        style: {
            maxHeight: 500
        },
    },
};

const CreateWatchDogReport = ({
    createInspectionReport,
    createWatchDogReport,
    fetchReportEquipment,
    fetchReportEquipmentTypes,
    fetchReportSites,
    handleBackClick,
    navClients,
    ...props
}) => {
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const [loading, setLoading] = useState(false);
    const [sitesLoading, setSitesLoading] = useState(false);
    const [equipmentLoading, setEquipmentLoading] = useState(false);
    const [clientList, setClientList] = useState([]);
    const [siteList, setSiteList] = useState([]);
    const [equipmentList, setEquipmentList] = useState([]);
    const [equipmentTypeList, setEquipmentTypeList] = useState([]);
    const [staticEquipment, setStaticEquipment] = useState([]);
    const [filterType, setFilterType] = useState('Status');

    // eslint-disable-next-line no-unused-vars
    const [currentYear, setCurrentYear] = useState();
    const [currentMonth, setCurrentMonth] = useState();

    const [years, setYears] = useState([]);
    const [months, setMonths] = useState([]);

    const [nestedPanes] = useState([
        { resizable: false },
        { size: '55px', resizable: false }
    ]);

    const [panes] = useState([
        { size: '650px', resizable: false }, {}
    ]);

    useEffect(() => {
        const thisYear = moment().year();
        const yearList = [thisYear, thisYear - 1, thisYear - 2];

        const monthList = moment.months();
        const thisMonth = moment().month();
        const legalMonths = [];
        monthList.forEach((target, index) => {
            if (index <= thisMonth) {
                legalMonths.push({
                    name: target,
                    index
                });

                if (index === thisMonth) {
                    setCurrentMonth(index);
                }
            }
        });

        setCurrentYear(thisYear);
        setYears(yearList);
        setMonths(legalMonths);
    }, []);

    useEffect(() => {
        if (navClients && isEmpty(clientList)) setClientList(navClients);
    }, [navClients]);

    const formik = useFormik({
        initialValues: {
            description:   'Watchdog Report for agent devices.',
            client:        '',
            site:          '',
            equipmentType: [],
            equipment:     [],
            system:        [],
            status:        'All',
            symbol:        '>',
            number:        '0',
            timeRange:     '',
            targetYear:    moment().year(),
            targetDate:    moment().month(),
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            let equipments = [];
            if (!isEmpty(values.equipment)) equipments = values.equipment.filter(item => item.id !== 0);
            const entityIds = equipments.map(item => item.id);

            const body = {
                clientId:    values.client.id,
                description: values.description,
                siteId:      values.site.id,
                reportType:  'watchdog',
                to:          '',
                from:        '',
                EntityIds:   entityIds,
                entityType:  0
            };

            if (filterType === 'Status') {
                switch (values.status) {
                    case 'All':
                        body.RangeValue = ['0', '100'];
                        break;
                    case 'Good':
                        body.RangeValue = ['75', '100'];
                        break;
                    case 'Ok':
                        body.RangeValue = ['50', '74'];
                        break;
                    case 'Bad':
                        body.RangeValue = ['0', '49'];
                        break;
                    default:
                        break;
                }
                body.symbol = '-';
            } else {
                body.symbol = values.symbol;
                body.value = values.number;
            }

            switch (values.timeRange) {
                case 'Today':
                    body.from= moment().startOf('day').valueOf();
                    body.to = moment().endOf('day').valueOf();
                    break;
                case 'Week to Day':
                    body.from = moment().startOf('week').valueOf();
                    body.to = moment().endOf('day').valueOf();
                    break;
                case 'Month to Day':
                    body.from = moment().startOf('month').valueOf();
                    body.to = moment().endOf('day').valueOf();
                    break;
                case 'Quarter to Day':
                    body.from = moment().startOf('quarter').valueOf();
                    body.to = moment().endOf('day').valueOf();
                    break;
                case 'Previous Day':
                    body.from = moment().subtract(1, 'day').startOf('day').valueOf();
                    body.to = moment().subtract(1, 'day').endOf('day').valueOf();
                    break;
                case 'Previous Week':
                    body.from = moment().subtract(1, 'week').startOf('week').valueOf();
                    body.to = moment().subtract(1, 'week').endOf('week').valueOf();
                    break;
                case 'Previous Month':
                    body.from = moment().subtract(1, 'month').startOf('month').valueOf();
                    body.to = moment().subtract(1, 'month').endOf('month').endOf('day').valueOf();
                    break;
                case 'Previous Quarter':
                    body.from = moment().subtract(1, 'quarter').startOf('quarter').valueOf();
                    body.to = moment().subtract(1, 'quarter').endOf('quarter').valueOf();
                    break;
                case 'Monthly':
                    body.from = moment().month(values.targetDate).year(values.targetYear).startOf('month').valueOf();
                    body.to = moment().month(values.targetDate).year(values.targetYear).endOf('month').valueOf();
                    break;
                case 'Custom Date':
                    body.from = moment(startDate).startOf('day').valueOf();
                    body.to = moment(endDate).endOf('day').valueOf();
                    break;
                default:
                    break;
            }

            body.from = new Date(body.from);
            body.to = new Date(body.to);

            try {
                setLoading(true);
                await createWatchDogReport(body);
                setLoading(false);
                handleBackClick('Watchdog Reports');
            } catch (error) {
                setLoading(false);
            }
        }
    });

    useEffect(() => {
        let updatedEquipmentList = [...staticEquipment].filter(item => item.id !== 0);

        const filter = formik.values.equipmentType.filter(item => item.id !== 0);
        if (!isEmpty(formik.values.equipmentType)) {
            const filtered = updatedEquipmentList.filter(item => filter.find(object => item.equipmentType.id === object.id));
            updatedEquipmentList = filtered;
        } else {
            updatedEquipmentList = staticEquipment;
        }

        if (!isEmpty(updatedEquipmentList) && !updatedEquipmentList.find(item => item.id === 0)) updatedEquipmentList.unshift({ id: 0, name: 'All' });
        setEquipmentList(updatedEquipmentList);
    }, [formik.values.equipmentType]);

    const renderTimeRangeHelperText = () => {
        let start = null;
        let end = null;

        if (formik.values.timeRange === 'Monthly') {
            start = moment().month(formik.values.targetDate).year(formik.values.targetYear).subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
            end = moment().month(formik.values.targetDate).year(formik.values.targetYear).subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
        } else if (formik.values.timeRange === 'Today') {
            start = moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD');
            end = moment().subtract(1, 'day').endOf('day').format('YYYY-MM-DD');
        } else if (formik.values.timeRange === 'Week to Day') {
            start = moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DD');
            end = moment().subtract(1, 'week').endOf('day').format('YYYY-MM-DD');
        } else if (formik.values.timeRange === 'Month to Day') {
            start = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
            end = moment().subtract(1, 'month').endOf('day').format('YYYY-MM-DD');
        } else if (formik.values.timeRange === 'Quarter to Day') {
            start = moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD');
            end = moment().subtract(1, 'quarter').endOf('day').format('YYYY-MM-DD');
        } else if (formik.values.timeRange === 'Previous Day') {
            start = moment().subtract(2, 'day').startOf('day').format('YYYY-MM-DD');
            end = moment().subtract(2, 'day').endOf('day').format('YYYY-MM-DD');
        } else if (formik.values.timeRange === 'Previous Week') {
            start = moment().subtract(2, 'week').startOf('week').format('YYYY-MM-DD');
            end = moment().subtract(2, 'week').endOf('week').format('YYYY-MM-DD');
        } else if (formik.values.timeRange === 'Previous Month') {
            start = moment().subtract(2, 'month').startOf('month').format('YYYY-MM-DD');
            end = moment().subtract(2, 'month').endOf('month').endOf('day').format('YYYY-MM-DD');
        } else if (formik.values.timeRange === 'Previous Quarter') {
            start = moment().subtract(2, 'quarter').startOf('quarter').format('YYYY-MM-DD');
            end = moment().subtract(2, 'quarter').endOf('quarter').format('YYYY-MM-DD');
        } else if (formik.values.timeRange === 'Custom Date') {
            let diff = 0;
            if (startDate && endDate) {
                diff = moment(endDate).add(1, 'day').endOf('day').diff(moment(startDate).startOf('day'), 'days');
            }

            start = moment(startDate).subtract(diff, 'days').startOf('day').format('YYYY-MM-DD');
            end = moment(endDate).subtract(diff, 'days').endOf('day').format('YYYY-MM-DD');
        }

        if (formik.values.timeRange === 'Custom Date') {
            if (startDate && endDate) {
                return <span className={classes.PreviousPeriod}>{`Previous Period: ${start} - ${end}`}</span>;
            } else {
                return null;
            }
        } else if (start && end) {
            return <span className={classes.PreviousPeriod}>{`Previous Period: ${start} - ${end}`}</span>;
        }
    };

    const handleClientChange = async (event, client) => {
        if (!client) {
            formik.setFieldValue('client', '', true);
            formik.setFieldValue('equipment', [], true);
            formik.setFieldValue('system', [], true);
            formik.setFieldValue('equipmentType', [], true);
            return;
        }

        formik.setFieldValue('client', client, true);
        setSitesLoading(true);
        const sites = await fetchReportSites(client.id);
        setSiteList(sites);
        setSitesLoading(false);

        formik.setFieldValue('equipment', [], true);
        formik.setFieldValue('site', '', true);
        formik.setFieldValue('system', [], true);
        formik.setFieldValue('equipmentType', [], true);
    };

    const handleSiteChange = async (event, site) => {
        if (!site) {
            formik.setFieldValue('site', '', true);
            formik.setFieldValue('equipment', [], true);
            formik.setFieldValue('system', [], true);
            formik.setFieldValue('equipmentType', [], true);
            return;
        }

        formik.setFieldValue('site', site, true);
        setEquipmentLoading(true);
        let equipment = await fetchReportEquipment(site.id);
        equipment = sortBy(equipment, 'name');
        setStaticEquipment(equipment);

        if (!isEmpty(equipment)) {
            equipment.unshift({ id: 0, name: 'All' });
        }

        let equipmentTypes = await fetchReportEquipmentTypes(site.id);

        equipmentTypes = sortBy(equipmentTypes, 'name');

        if (!isEmpty(equipmentTypes)) {
            equipmentTypes.unshift({ id: 0, name: 'All' });
        }

        setEquipmentTypeList(equipmentTypes);
        setEquipmentList(equipment);
        setEquipmentLoading(false);

        formik.setFieldValue('equipment', [], true);
        formik.setFieldValue('system', [], true);
        formik.setFieldValue('equipmentType', [], true);
    };

    const handleEquipmentTypeChange = (event, values) => {
        if (event.target.textContent === 'All' || event.target.value === '0') {
            if (formik.values.equipmentType.some(item => item.id === 0)) {
                formik.setFieldValue('equipmentType', [], true);
            } else {
                formik.setFieldValue('equipmentType', equipmentTypeList, true);
            }
        } else {
            if (values.length !== equipmentTypeList.length) {
                let updatedValues = [...values];
                updatedValues = updatedValues.filter(item => item.id !== 0);
                formik.setFieldValue('equipmentType', updatedValues, true);
            } else {
                formik.setFieldValue('equipmentType', values, true);
            }
        }
    };

    const handleEquipmentChange = (event, values) => {
        if (event.target.textContent === 'All' || event.target.value === '0') {
            if (formik.values.equipment.some(item => item.id === 0)) {
                formik.setFieldValue('equipment', [], true);
            } else {
                formik.setFieldValue('equipment', equipmentList, true);
            }
        } else {
            if (values.length !== equipmentList.length) {
                let updatedValues = [...values];
                updatedValues = updatedValues.filter(item => item.id !== 0);
                formik.setFieldValue('equipment', updatedValues, true);
            } else {
                formik.setFieldValue('equipment', values, true);
            }
        }
    };

    const handleTimeRangeChange = (event, timeRange) => {
        formik.setFieldValue('timeRange', timeRange, true);
    };

    const handleTargetYearChange = event => {
        const { value } = event.target;

        const monthList = moment.months();

        if (moment().year() === value) {
            const legalMonths = [];
            const { targetDate } = formik.values;

            monthList.forEach((target, index) => {
                if (index <= currentMonth) {
                    legalMonths.push({
                        name: target,
                        index
                    });
                }
            });

            if (targetDate > currentMonth) {
                formik.setFieldValue('targetDate', currentMonth, false);
            }

            setMonths(legalMonths);
        } else {
            const allMonths = [];

            monthList.forEach((target, index) => {
                allMonths.push({
                    name: target,
                    index
                });
            });

            setMonths(allMonths);
        }

        formik.handleChange(event);
    };

    const handleTargetDateChange = event => {
        const { value } = event.target;

        formik.setFieldValue('targetDate', value, false);
    };

    const handleRadioChange = event => {
        setFilterType(event.target.value);
    };

    const handleCancel = () => {
        handleBackClick('Watchdog Reports');
    };

    return (
        <React.Fragment>
            <style>
                {
                    `.k-splitter-flex .k-pane-static {
                        flex-grow: 0;
                        flex-shrink: 0;
                        flex-basis: fit-content;
                    }
                    `
                }
            </style>
            <Splitter
                panes={nestedPanes}
                orientation={'vertical'}
            >
                <div>
                    <Splitter style={{ height: '646px' }} panes={panes}>
                        <div className={classes.FormPane}>
                            <FormControl className={Boolean(formik.errors.client) && Boolean(formik.touched.client) ? classes.ErrorWrapper : classes.InputWrapper}>
                                <AutoComplete
                                    id="client"
                                    name="client"
                                    options={sortBy(clientList, 'name')}
                                    getOptionLabel={(option) => option.name || ''}
                                    getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                                    value={formik.values.client}
                                    onChange={handleClientChange}
                                    onBlur={formik.handleBlur}
                                    size="small"
                                    required
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            className={classes.Required}
                                            label="Client"
                                            variant="outlined"
                                            required={true}
                                            error={Boolean(formik.errors.client) && Boolean(formik.touched.client)}
                                            helperText={Boolean(formik.touched.client) && formik.errors.client}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {loading ? <CircularProgress color="inherit" size={15} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />}
                                />
                            </FormControl>
                            <FormControl className={Boolean(formik.errors.site) && Boolean(formik.touched.site) ? classes.ErrorWrapper : classes.InputWrapper}>
                                <AutoComplete
                                    id="site"
                                    name="site"
                                    disabled={isEmpty(formik.values.client)}
                                    options={sortBy(siteList, 'name')}
                                    getOptionLabel={(option) => option.name || ''}
                                    getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                                    value={formik.values.site}
                                    onChange={handleSiteChange}
                                    onBlur={formik.handleBlur}
                                    size="small"
                                    required
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            className={classes.Required}
                                            label="Site"
                                            variant="outlined"
                                            required={true}
                                            error={Boolean(formik.errors.site) && Boolean(formik.touched.site)}
                                            helperText={Boolean(formik.touched.site) && formik.errors.site}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {sitesLoading ? <CircularProgress color="inherit" size={15} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />}
                                />
                            </FormControl>
                            <FormControl className={classes.InputWrapper}>
                                <AutoComplete
                                    id="equipmentType"
                                    name="equipmentType"
                                    multiple
                                    disableCloseOnSelect
                                    disabled={isEmpty(formik.values.site)}
                                    options={equipmentTypeList}
                                    getOptionLabel={(option) => option.name || ''}
                                    getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                                    value={formik.values.equipmentType}
                                    onChange={handleEquipmentTypeChange}
                                    onBlur={formik.handleBlur}
                                    size="small"
                                    renderTags={(value, getTagProps) => value.map((option, index) => {
                                        if (index < 2) {
                                            return (
                                                <Chip
                                                    classes={{
                                                        root: classes.Chip
                                                    }}
                                                    variant="outlined"
                                                    label={option.name}
                                                    {...getTagProps({ index })}
                                                />
                                            );
                                        } else if (index === 2) {
                                            return (<span className={classes.Tag}>{` + ${value.length - 2} Selected`}</span>);
                                        } else {
                                            return null;
                                        }
                                    })}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <Checkbox
                                                value={option.id}
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option.name}
                                        </React.Fragment>
                                    )}
                                    required
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            className={classes.Required}
                                            label="Equipment Type"
                                            variant="outlined"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {equipmentLoading ? <CircularProgress color="inherit" size={15} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />}
                                />
                            </FormControl>
                            <FormControl className={Boolean(formik.errors.equipment) && Boolean(formik.touched.equipment) ? classes.ErrorWrapper : classes.InputWrapper}>
                                <AutoComplete
                                    id="equipment"
                                    name="equipment"
                                    multiple
                                    disableCloseOnSelect
                                    disabled={isEmpty(formik.values.site)}
                                    options={equipmentList}
                                    getOptionLabel={(option) => option.name || ''}
                                    value={formik.values.equipment}
                                    onChange={handleEquipmentChange}
                                    size="small"
                                    renderTags={(value, getTagProps) => value.map((option, index) => {
                                        if (index < 2) {
                                            return (
                                                <Chip
                                                    key={option.id}
                                                    classes={{
                                                        root: classes.Chip
                                                    }}
                                                    onMouseDown={(event) => {
                                                        event.stopPropagation();
                                                    }}
                                                    variant="outlined"
                                                    label={option.name}
                                                    //onDelete={() => handleDeleteChip(option, 'equipment')}
                                                />
                                            );
                                        } else if (index === 2) {
                                            return (<span id={option.index} className={classes.Tag}>{` + ${value.length - 2} Selected`}</span>);
                                        } else {
                                            return null;
                                        }
                                    })}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment key={option.id}>
                                            <Checkbox
                                                value={option.id}
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option.name}
                                        </React.Fragment>
                                    )}
                                    required={isEmpty(formik.values.system)}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            className={classes.Required}
                                            label="Equipment"
                                            variant="outlined"
                                            required={isEmpty(formik.values.system)}
                                            error={Boolean(formik.errors.equipment) && Boolean(formik.touched.equipment)}
                                            helperText={Boolean(formik.touched.equipment) && formik.errors.equipment}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {equipmentLoading ? <CircularProgress color="inherit" size={15} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />}
                                />
                            </FormControl>
                            <span>
                                <FormControl style={{width: '25%'}}>
                                    <RadioGroup
                                        row
                                        name="row-radio-buttons-group"
                                        value={filterType}
                                        onChange={(e) => handleRadioChange(e)}
                                    >
                                        <FormControlLabel
                                            className={classes.FormLabel}
                                            value="Status"
                                            control={<BobRadioButton size="small" />}
                                            label="Status"
                                        />
                                        <FormControlLabel
                                            className={classes.FormLabel}
                                            value="Value"
                                            control={<BobRadioButton size="small" />}
                                            label="Value"
                                        />
                                    </RadioGroup>
                                </FormControl>
                                <FormControl
                                    variant="outlined"
                                    size="small"
                                    style={filterType === 'Status' ? { width: '75%' } : { width: '75%', display: 'inline-block' }}
                                    className={classes.InputWrapper}
                                >
                                    {
                                        filterType === 'Status' ?
                                            <React.Fragment>
                                                <InputLabel id="status">
                                                    Status
                                                </InputLabel>
                                                <Select
                                                    labelId="status"
                                                    id="status"
                                                    name="status"
                                                    value={formik.values.status}
                                                    onChange={formik.handleChange}
                                                    className={classes.select}
                                                    MenuProps={MenuProps}
                                                >
                                                    <MenuItem className={classes.MenuItem} value="All">
                                                        All
                                                    </MenuItem>
                                                    <MenuItem className={classes.MenuItem} value="Good">
                                                        Good
                                                    </MenuItem>
                                                    <MenuItem className={classes.MenuItem} value="Ok">
                                                        Ok
                                                    </MenuItem>
                                                    <MenuItem className={classes.MenuItem} value="Bad">
                                                        Bad
                                                    </MenuItem>
                                                </Select>
                                            </React.Fragment>
                                            :
                                            <React.Fragment>
                                                <InputLabel id="symbol">
                                                    Symbol
                                                </InputLabel>
                                                <Select
                                                    style={{width: '48%', marginRight: '1rem'}}
                                                    labelId="symbol"
                                                    id="symbol"
                                                    name="symbol"
                                                    value={formik.values.symbol}
                                                    onChange={formik.handleChange}
                                                    className={classes.select}
                                                    MenuProps={MenuProps}
                                                >
                                                    <MenuItem className={classes.MenuItem} value=">">
                                                        {'>'}
                                                    </MenuItem>
                                                    <MenuItem className={classes.MenuItem} value=">=">
                                                        {'>='}
                                                    </MenuItem>
                                                    <MenuItem className={classes.MenuItem} value="<">
                                                        {'<'}
                                                    </MenuItem>
                                                    <MenuItem className={classes.MenuItem} value="<=">
                                                        {'<='}
                                                    </MenuItem>
                                                </Select>
                                                <TextField
                                                    style={{width: '49.8%'}}
                                                    type="number"
                                                    name="number"
                                                    className={classes.Required}
                                                    label="Value"
                                                    variant="outlined"
                                                    size="small"
                                                    required={true}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.number}
                                                />

                                            </React.Fragment>
                                    }
                                </FormControl>
                            </span>
                            <FormControl className={Boolean(formik.errors.timeRange) && Boolean(formik.touched.timeRange) ? classes.ErrorTimeRangeWrapper : classes.TimeRangeInputWrapper}>
                                <div className={classes.DateSelector}>
                                    <AutoComplete
                                        id="timeRange"
                                        name="timeRange"
                                        options={timeRanges}
                                        getOptionLabel={(option) => option || ''}
                                        value={formik.values.timeRange}
                                        onChange={handleTimeRangeChange}
                                        onBlur={formik.handleBlur}
                                        size="small"
                                        required
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                className={classes.Required}
                                                label="Time Range"
                                                variant="outlined"
                                                required={true}
                                                error={Boolean(formik.errors.timeRange) && Boolean(formik.touched.timeRange)}
                                                helperText={renderTimeRangeHelperText()}
                                            />}
                                    />
                                </div>
                                {
                                    formik.values.timeRange === 'Custom Date' ?
                                        <div className={classes.DatePicker}>
                                            <DatePicker
                                                popperPlacement="top-end"
                                                selectsRange={true}
                                                startDate={startDate}
                                                endDate={endDate}
                                                onChange={(update) => {
                                                    setDateRange(update);
                                                }}
                                                maxDate={startDate ? new Date(moment(startDate).add(3, 'months')) : new Date()}
                                                minDate={new Date(moment().subtract(3, 'years'))}
                                                isClearable={true}
                                            />
                                        </div>
                                        :
                                        null
                                }
                            </FormControl>
                            <FormControl className={classes.MonthRangeInputWrapper}>
                                {
                                    formik.values.timeRange === 'Monthly' ?
                                        <React.Fragment>
                                            <FormControl
                                                variant="outlined" size="small"
                                                className={classes.leftInputWrapper}
                                            >
                                                <InputLabel
                                                    htmlFor="targetYear"
                                                    classes={{
                                                        error:   classes.error,
                                                        focused: classes.labelFocused,
                                                        root:    classes.label
                                                    }}
                                                    error={Boolean(formik.errors.targetYear) && Boolean(formik.touched.targetYear)}
                                                >
                                                    Target Year
                                                </InputLabel>
                                                <Select
                                                    name="targetYear"
                                                    className={classes.select}
                                                    MenuProps={MenuProps}
                                                    id="targetYear"
                                                    value={formik.values.targetYear}
                                                    onChange={handleTargetYearChange}
                                                    inputProps={{
                                                        onBlur: formik.handleBlur
                                                    }}
                                                    error={Boolean(formik.errors.targetYear) && Boolean(formik.touched.targetYear)}
                                                >
                                                    {
                                                        years.map((item, index) =>
                                                            <MenuItem
                                                                key={index}
                                                                value={item}
                                                            >
                                                                {item}
                                                            </MenuItem>
                                                        )
                                                    }
                                                </Select>
                                                {formik.touched.targetYear &&
                                                    formik.errors.targetYear && <FormHelperText className={classes.error}>{formik.errors.targetYear}</FormHelperText>}
                                            </FormControl>
                                            <FormControl
                                                variant="outlined" size="small"
                                                className={classes.rightInputWrapper}
                                            >
                                                <InputLabel
                                                    htmlFor="targetDate"
                                                    classes={{
                                                        error:   classes.error,
                                                        focused: classes.labelFocused,
                                                        root:    classes.label
                                                    }}
                                                    error={Boolean(formik.errors.targetDate) && Boolean(formik.touched.targetDate)}
                                                >
                                                    Target Month
                                                </InputLabel>
                                                <Select
                                                    name="targetDate"
                                                    id="targetDate"
                                                    className={classes.select}
                                                    MenuProps={MenuProps}
                                                    value={formik.values.targetDate}
                                                    onChange={handleTargetDateChange}
                                                    inputProps={{
                                                        onBlur: formik.handleBlur
                                                    }}
                                                    error={Boolean(formik.errors.targetDate) && Boolean(formik.touched.targetDate)}
                                                >
                                                    {
                                                        months.map((item, index) =>
                                                            <MenuItem
                                                                key={index}
                                                                value={item.index}
                                                            >
                                                                {item.name}
                                                            </MenuItem>
                                                        )
                                                    }
                                                </Select>
                                                {formik.touched.targetDate &&
                                                    formik.errors.targetDate && <FormHelperText className={classes.error}>{formik.errors.targetDate}</FormHelperText>}
                                            </FormControl>
                                        </React.Fragment>
                                        :
                                        null
                                }
                            </FormControl>
                        </div>
                        <div className={classes.TabPane} />
                    </Splitter>
                </div>
                <div className={classes.ButtonPane}>
                    <BobConfirmButton
                        className={classes.Buttons}
                        disabled={formik.values.timeRange === 'Custom Date' && (startDate === null || endDate === null)}
                        onClick={formik.handleSubmit}
                        label={'Save'}
                        iconSize={15}
                        isLoading={loading}
                    />
                    <BobCancelButton
                        className={classes.CancelButton}
                        onClick={handleCancel}
                        disabled={loading}
                        label={'Cancel'}
                    />
                </div>
            </Splitter>
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        bobLoading:       state.bob.bobLoading,
        currentUser:      state.currentUser,
        navClients:       state.bob.navClients,
        navClientsMeta:   state.bob.navClientsMeta
    };
};

const mapDispatchToProps = {
    ...ReportingActions
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateWatchDogReport);
